<template>
    <div class="simple-form">
        <el-form :model="shopDevice" :rules="shopDeviceRules" ref="shopDeviceInfo" class="demo-ruleForm">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">资产描述全称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="title">
                        <el-input v-model="shopDevice.title" style="width:300px;" disabled="true" placeholder="请输入设备名称"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="shopDevice.sellerId != null">
                <div class="form-label">
                    <label>供应商名称</label>
                </div>
                <div class="form-value">
                    <span>{{shopDevice.sellerName}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="shopDevice.brandId != null">
                <div class="form-label">
                    <label>品牌</label>
                </div>
                <div class="form-value">
                    <span>{{shopDevice.brandName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>分类</label>
                </div>
                <div class="form-value">
                    <span>{{shopDevice.catName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>商品标识码</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.vendorUkno || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required" v-if="devcGroupEdit">维保分组</label>
                    <label v-else>维保分组</label>
                </div>
                <div class="form-value width-2x">
                    <span v-if="devcGroupEdit">
                        <el-input class="width-1-5x bottom-line" :readonly="true" v-model="shopDevice.devcMaintAspkt.devcGroupFullName"></el-input>
                        <a class="swb-btn swb-btn-link" @click="selectDevcGroup(shopDevice)">选择</a>
                    </span>
                    <span v-else>{{shopDevice.devcMaintAspkt.devcGroupFullName || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>系统编号</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.tmpNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>服务子号</label>
                </div>
                <div class="form-value">
                    <span>{{ shopDevice.svcSubNo || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>责任部门</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="departName">
                        <el-input class="width-1-5x bottom-line" :readonly="true" v-model="shopDevice.devcMgmtAspkt.respblDepartName"></el-input>
                        <a class="swb-btn swb-btn-link" @click="setStaff(shopDevice.retailerBizUnitId)">选择</a>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>责任人</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="principalName">
                        <el-input class="width-1-5x bottom-line" :readonly="true" v-model="shopDevice.devcMgmtAspkt.respblStaffName"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div v-if="fuscakAcc != null && fuscakAcc == true">
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">残值率(%)</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="rmnWorthRatio">
                            <el-input placeholder="请输入残值率" type="number" :min="0" v-model="shopDevice.devcAssetAspkt.rmnWorthRatio" :disabled="shopDevice.devcAssetAspkt.devcDefId != null && shopDevice.devcAssetAspkt.devcDefId != -1"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <!-- 原值没有的时候才可以修改，有值就不能修改，为0也不能修改 -->
                <div class="form-group" v-if="shopDevice.editOrgWorth">
                    <div class="form-label">
                        <label class="required">原值（元）</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="orgWorth">
                            <el-input placeholder="请输入原值" type="number" :min="0" v-model="shopDevice.devcAssetAspkt.orgWorth"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">使用年限(月)</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="durableLife">
                            <el-input placeholder="请输入净值" :disabled="shopDevice.devcAssetAspkt.devcDefId != null && shopDevice.devcAssetAspkt.devcDefId != -1" type="number" :min="1" v-model="shopDevice.devcAssetAspkt.durableLife" @change="expectedLifeChange(shopDevice)"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>统一商品代码(UPC)</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="upn">
                        <el-input v-model="shopDevice.upc" placeholder="请输入UPC"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>外部系统编号</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="innerNo">
                        <el-input v-model="shopDevice.innerNo" placeholder="请输入外部系统编号"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>厂商序列号</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="vendorSn">
                        <el-input v-model="shopDevice.vendorSn" placeholder="请输入厂商序列号"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>位置编码</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="locCode">
                        <span>SBWZ</span>
                        <el-input class="width-1-5x" v-model="shopDevice.locCode" placeholder="请输入位置编码"></el-input>
                    </el-form-item>
                </div>
            </div>
            <!-- 资产台账 不显示【需要控温】 -->
            <div class="form-group center" v-if="!(fuscakAcc != null && fuscakAcc == true)">
                <div class="form-label">
                    <label class="required">需要控温</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="temperFlag">
                        <el-radio-group v-model="shopDevice.devcMaintAspkt.temperFlag">
                            <el-radio :label="true">需要</el-radio>
                            <el-radio :label="false">不需要</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="shopDevice.devcMaintAspkt.temperFlag">
                <div class="form-label">
                    <label class="required">温度低值(°c)</label>
                </div>
                <div class="form-value width-3x">
                    <el-form-item prop="temperLow">
                        <el-input class="inline-block width-1-5x" v-model="shopDevice.devcMaintAspkt.temperLow" placeholder="请输入温度" @change="temperLowChange(shopDevice)"></el-input>
                        <span class="inline-block font-orange">只保留两位小数</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="shopDevice.devcMaintAspkt.temperFlag">
                <div class="form-label">
                    <label class="required">温度高值(°c)</label>
                </div>
                <div class="form-value ">
                    <el-form-item prop="temperHigh">
                        <el-input class="inline-block width-1-5x" v-model="shopDevice.devcMaintAspkt.temperHigh" placeholder="请输入温度" @change="temperHighChange(shopDevice)"></el-input>
                        <span class="inline-block font-orange">只保留两位小数</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>备注</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="memo">
                        <el-input type="textarea" placeholder="请描述备注" v-model="shopDevice.memo"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>备注1</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="memo">
                        <el-input type="textarea" placeholder="请描述备注" v-model="shopDevice.memo1"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>备注2</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="memo">
                        <el-input type="textarea" placeholder="请描述备注" v-model="shopDevice.memo2"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>备注3</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="memo">
                        <el-input type="textarea" placeholder="请描述备注" v-model="shopDevice.memo3"></el-input>
                    </el-form-item>
                </div>
            </div>

            <template v-if="showDevcCustTag">
                <div class="form-group center" v-if="devcCustTag1.enabled">
                    <div class="form-label">
                        <label>{{ devcCustTag1.dispName }}</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="devcCustTag1">
                            <el-select :disabled="devcCustTag1.refUsed" v-model="shopDevice.devcCustTag1" placeholder="请选择" style="width: 150px" clearable>
                                <el-option v-for="item in devcCustTag1.itemList" :label="item.disabled?item.name+'(已禁用)':item.name" :value="item.id" :disabled="item.disabled"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="devcCustTag2.enabled">
                    <div class="form-label">
                        <label>{{ devcCustTag2.dispName }}</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="devcCustTag2">
                            <el-select :disabled="devcCustTag2.refUsed" v-model="shopDevice.devcCustTag2" placeholder="请选择" style="width: 150px" clearable>
                                <el-option v-for="item in devcCustTag2.itemList" :label="item.disabled?item.name+'(已禁用)':item.name" :value="item.id" :disabled="item.disabled"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="devcCustTag3.enabled">
                    <div class="form-label">
                        <label>{{ devcCustTag3.dispName }}</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="devcCustTag3">
                            <el-select :disabled="devcCustTag3.refUsed" v-model="shopDevice.devcCustTag3" placeholder="请选择" style="width: 150px" clearable>
                                <el-option v-for="item in devcCustTag3.itemList" :label="item.disabled?item.name+'(已禁用)':item.name" :value="item.id" :disabled="item.disabled"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </template>

            <div class="form-group center">
                <div class="form-label">
                    <label>资产图片</label>
                </div>
                <div class="form-value">
                    <swb-file-upload :fileFor="'solution'" fileGroup="image-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="false"></swb-file-upload>
                    <div class="file-area clearfix" v-if="shopDeviceImg.fileBrowseUrl != null">
                        <swb-file-item :fileName="shopDeviceImg.fileName" :fileBrowseUrl="shopDeviceImg.fileBrowseUrl" :fileUuid="shopDeviceImg.fileUuid" :deletable="true" :onDelete="removeUpload"></swb-file-item>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import{ openComStaffMainForSelectDlg, openComStaffComnSelectDlg } from '../orgStruct/selectDlg'
    import { loadAssetDeprMethodList } from '../retailer/asset-comn'
    import { showDevcGroupSelectDlg } from '../categ/selectDlg'
    //
    import shopDevcApi from '../../api/shopDevc'
    import devcApi from '../../api/devc'
    import assetApi from '../../api/asset'
    import retailerApi from '../../api/retailer'
    import custTagMeataApi from '../../api/objTagConf'
    //
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);
    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);

    export default {
        name: 'swb-shop-device-svcSubNo-edit',
        desc: '机构资产服务子号-编辑',
        props: {
            devcId: {
                type: Object,
                default: {}
            },
            fuscakAcc: {
                type: Object,
                default: null
            },
            showDevcCustTag: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空！'));
                } else {
                    callback();
                }
            };
            return {
                shopDevice: {
                    devcAssetAspkt: {},
                    devcMaintAspkt: {},
                    devcMgmtAspkt: {},
                },
                shopDeviceRules: {
                    title: [{validator: checkNull, trigger: 'blur'}],
                },
                devcGroupEdit: false,
                // 资产图片
                shopDeviceImg: {},
                assetDeprMethodList: [],

                devcCustTag1: {
                    dispName: '自定义标签1',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                },
                devcCustTag2: {
                    dispName: '自定义标签2',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                },
                devcCustTag3: {
                    dispName: '自定义标签3',
                    itemList: [],
                    enabled: false,
                    refUsed: false
                },
            }
        },
        created: function () {
            let self = this;
            self.getCustTagMetaFields();

            // 折旧算法
            let assetType = getEnumInfoWith('assetType', 'name', 'CommonDevc').value;
            loadAssetDeprMethodList(assetType, function (dataList) {
                self.assetDeprMethodList = Utils.merge([], dataList);
            });
            self.getShopDeviceBySvcSubNo();

        },
        watch:{
            'shopDevice.devcCustTag1'(newVal, oldVal) {
                this.shopDevice.devcCustTag1 = this.filterListValue(this.devcCustTag1.itemList, newVal)
            },
            'shopDevice.devcCustTag2'(newVal, oldVal) {
                this.shopDevice.devcCustTag2 = this.filterListValue(this.devcCustTag2.itemList, newVal)
            },
            'shopDevice.devcCustTag3'(newVal, oldVal) {
                this.shopDevice.devcCustTag3 = this.filterListValue(this.devcCustTag3.itemList, newVal)
            }
        },
        methods: {
            // 使用年限(月)校验
            expectedLifeChange: function (shopDevice) {
                let durableLife = shopDevice.durableLife;
                if(!Utils.isNaturalStr(durableLife) || durableLife <= 0) {
                    shopDevice.durableLife = null;
                    MsgBox.warning("使用年限(月)必须为大于0的整数!");
                }
            },
            // 温度低值校验
            temperLowChange: function (shopDevice) {
                let temperLow = shopDevice.devcMaintAspkt.temperLow;
                if(!Utils.isNoB(temperLow)) {
                    let low = temperLow;
                    if(low.indexOf('-') > -1) {
                        low = low.substring(1, low.length);
                    }
                    if(Utils.isMoneyStr(low)) {
                        let temperLowF = parseFloat(temperLow);
                        shopDevice.devcMaintAspkt.temperLow = temperLowF.toFixed(2);
                        let temperHigh = shopDevice.devcMaintAspkt.temperHigh;
                        if(!Utils.isNoB(temperHigh)) {
                            let temperHighF = parseFloat(temperHigh);
                            if(temperLowF > temperHighF) {
                                shopDevice.devcMaintAspkt.temperLow = null;
                                MsgBox.warning("温度低值要小于温度高值!");
                            }
                        }
                    } else {
                        shopDevice.devcMaintAspkt.temperLow = null;
                        MsgBox.warning("请输入正确的温度!");
                    }
                }
            },
            // 温度高值校验
            temperHighChange: function (shopDevice) {
                let temperHigh = shopDevice.devcMaintAspkt.temperHigh;
                if(!Utils.isNoB(temperHigh)) {
                    let high = temperHigh;
                    if(high.indexOf('-') > -1) {
                        high = high.substring(1, high.length);
                    }
                    if(Utils.isMoneyStr(high)) {
                        let temperHighF = parseFloat(temperHigh);
                        shopDevice.devcMaintAspkt.temperHigh = temperHighF.toFixed(2);
                        let temperLow = shopDevice.devcMaintAspkt.temperLow;
                        if(!Utils.isNoB(temperLow)) {
                            let temperLowF = parseFloat(temperLow);
                            if(temperLowF > temperHighF) {
                                shopDevice.devcMaintAspkt.temperHigh = null;
                                MsgBox.warning("温度高值要大于温度低值!");
                            }
                        }
                    } else {
                        shopDevice.devcMaintAspkt.temperHigh = null;
                        MsgBox.warning("请输入正确的温度!");
                    }
                }
            },

             getCustTagMetaFields: function () {
                let self = this
                 let param = [{tagMetaTableName: 'shop_device', tagMetaRole: 1}]
                custTagMeataApi.getCustTagMetaFields(param, function (result) {
                    if (result.type == 'info') {
                        let tags = result.data
                        for(let i=0; i< tags.length; i++) {
                            let tag = tags[i]
                            if(tag.fieldName == 'devcCustTag1') {
                                self.devcCustTag1 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            } else if(tag.fieldName == 'devcCustTag2') {
                                self.devcCustTag2 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            } else if(tag.fieldName == 'devcCustTag3') {
                                self.devcCustTag3 = {
                                    dispName: tag.dispName,
                                    itemList: tag.itemList,
                                    enabled: tag.enabled,
                                    refUsed: tag.refUsed
                                }
                            }
                        }
                    } else {
                        MsgBox.warning(result.message)
                    }
                });
            },
            //
            getShopDeviceBySvcSubNo: function () {
                let self = this;
                let postData = {
                    id: this.devcId,
                    containMgmt: true,
                    containAsset: true,
                    containMaint: true,
                };
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceById(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let shopDevice = result.data;
                        shopDevice.editOrgWorth = Utils.isNoB(shopDevice.devcAssetAspkt.orgWorth);
                        if(shopDevice.devcMgmtAspkt.startDate == null) {
                            shopDevice.startDateEditd = true;
                        }
                        let devcMaintAspkt = shopDevice.devcMaintAspkt || {};
                        if(Utils.isNoB(devcMaintAspkt.devcGroupId) || devcMaintAspkt.devcGroupId <= 0) {
                            self.devcGroupEdit = true;
                        }
                        self.shopDeviceImg.fileBrowseUrl = shopDevice.imageUrl || null;
                        //
                        shopDevice.devcMaintAspkt = Utils.merge({}, devcMaintAspkt);
                        if(!Utils.isNoB(shopDevice.locCode)){
                            shopDevice.locCode = shopDevice.locCode.substring(4, shopDevice.locCode.length);
                        }
                        self.shopDevice = Utils.merge({}, shopDevice);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择维保分组
            selectDevcGroup: function () {
                let self = this;
                let shopDevice = self.shopDevice || {};
                //
                let params = {
                    filter: {
                        level: 2
                    },
                    checkBox: false
                };
                showDevcGroupSelectDlg(params, function (devcGroup, theDlg) {
                    theDlg.close();
                    let devcMaintAspkt = shopDevice.devcMaintAspkt || {};
                    devcMaintAspkt.devcGroupId = devcGroup.id;
                    devcMaintAspkt.devcGroupId1 = devcGroup.parentId;
                    devcMaintAspkt.devcGroupId2 = devcGroup.id;
                    devcMaintAspkt.devcGroupName = devcGroup.name;
                    devcMaintAspkt.devcGroupFullName = devcGroup.fullName;

                    shopDevice.devcMaintAspkt = Utils.merge({}, devcMaintAspkt);
                    self.shopDevice = Utils.merge({}, shopDevice);
                });
            },
            // 选择部门
            setStaff: function (retailerBizUnitId) {
                let self = this;
                let shopDevice = self.shopDevice || {};
                openComStaffMainForSelectDlg({defComId: retailerBizUnitId, bizUnitId: retailerBizUnitId}, function (staff, theDlg) {
                    theDlg.close();
                    let devcMgmtAspkt = shopDevice.devcMgmtAspkt || {};
                    devcMgmtAspkt.respblDepartId = staff.srcComId;
                    devcMgmtAspkt.respblDepartName = staff.srcComName;
                    devcMgmtAspkt.respblDepartFullName = staff.srcComFullName;
                    devcMgmtAspkt.respblStaffId = staff.id;
                    devcMgmtAspkt.respblStaffName = staff.name;
                    shopDevice.devcMgmtAspkt = Utils.merge({}, devcMgmtAspkt);
                    self.shopDevice = Utils.merge({}, shopDevice);
                });
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files || [];
                    let file = files[0];
                    let shopDeviceImg = {};
                    shopDeviceImg.fileName = file.fileName;
                    shopDeviceImg.fileUuid = file.fileUuid;
                    shopDeviceImg.fileExtName = file.fileExtName;
                    shopDeviceImg.fileBrowseUrl = file.fileBrowseUrl;
                    shopDeviceImg.fileDownloadUrl = file.fileDownloadUrl;
                    shopDeviceImg.fileMd5 = file.fileMd5;
                    self.shopDeviceImg = shopDeviceImg;
                } else {
                    MsgBox.warning(result.message);
                }
            },
            removeUpload: function () {
                this.shopDeviceImg = {};
                return false;
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                let shopDevice = Utils.merge({}, self.shopDevice);
                if(Utils.isNoB(shopDevice.devcMaintAspkt.devcGroupId)) {
                    MsgBox.warning("维保分组不可为空");
                    return;
                }
                if(Utils.isTrue(self.fuscakAcc)) {
                    if(Utils.isNoB(shopDevice.devcAssetAspkt.rmnWorthRatio)) {
                        self.$message.warning("残值率不可为空");
                        return;
                    }
                    if(Utils.isNoB(shopDevice.devcAssetAspkt.durableLife)) {
                        self.$message.warning("使用年限不可为空");
                        return;
                    }
                    if(Utils.isTrue(shopDevice.editOrgWorth)) {
                        if(Utils.isNoB(shopDevice.devcAssetAspkt.orgWorth)) {
                            self.$message.warning("原值不可为空");
                            return;
                        }
                    }
                }
                if(Utils.isNoB(shopDevice.locCode)){
                    shopDevice.locCode = '';
                } else {
                    shopDevice.locCode = shopDevice.locCode.trim();
                    if(shopDevice.locCode.length > 18){
                        self.$message.warning("位置编码最长22位，前缀固定SBWZ");
                        return;
                    }
                    shopDevice.locCode = 'SBWZ' + shopDevice.locCode;
                }
                if(shopDevice.devcMaintAspkt.temperFlag){
                    if(Utils.isNoB(shopDevice.devcMaintAspkt.temperLow)){
                        MsgBox.warning("请输入温度低值!");
                        return;
                    }
                    if(Utils.isNoB(shopDevice.devcMaintAspkt.temperHigh)){
                        MsgBox.warning("请输入温度高值!");
                        return;
                    }
                }
                this.$refs['shopDeviceInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        shopDevice.imageUrl = self.shopDeviceImg.fileBrowseUrl || "";
                        //
                        result.data = shopDevice;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            },
            filterListValue(listItems, listVal) {
                let listValues = listItems.pluck('id')
                let reval = listValues.indexOf(listVal) == -1?null:listVal;
                return reval;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceSvcSubNoEdit.vue